import React from 'react';
import { RegionReportSpinner } from '../../RegionReportSpinner/RegionReportSpinner';
import styles from '../../RegionReport.css';

export type LoadingViewProps = {
  onCancelClick: () => void;
};

export const LoadingView = ({
  onCancelClick,
}: LoadingViewProps) => (
  <div data-test-id='dmb-region-report-loading' className={styles.regionReportContainer}>
    <RegionReportSpinner onCancelClick={onCancelClick} />
  </div>
);
